import {
  ICommentResponse,
  ICommentResponseBody,
  ICreatePost,
  IPostEditResponse,
  IPostCreateResponse,
  IPostDeleteResponseBody,
  IVisibilityResponse,
  IPostQuery,
  IPostListResponse,
  ICommentsResponse,
} from '../../interface/postModel';
import api from '../api';
import apiMultipart from '../api-multipart';

export const deleteComment = async (id: string): Promise<IPostDeleteResponseBody> => {
  const response = await api.delete<IPostDeleteResponseBody>(`/post/comments/${id}`);

  return response.data;
};

export const deletePost = async (id: string): Promise<IPostDeleteResponseBody> => {
  const response = await api.delete<IPostDeleteResponseBody>(`/post/${id}`);

  return response.data;
};

export const fetchComment = async (id: string): Promise<ICommentResponse> => {
  const response = await api.get<ICommentResponse>(`/post/record/${id}`);

  return response.data;
};

export const commentPost = async ({
  body,
  input,
}: {
  body: string;
  input: string;
}): Promise<ICommentResponseBody> => {
  const response = await api.post<ICommentResponseBody>(`/post/comment`, {
    postTemplateId: body,
    commentText: input,
  });

  return response.data;
};

export const postVisibility = async (): Promise<IVisibilityResponse> => {
  const response = await api.get<IVisibilityResponse>(`/post/visibility`);
  return response.data;
};

export const postCreate = async (payload: ICreatePost): Promise<IPostCreateResponse> => {
  const response = await apiMultipart.post<IPostCreateResponse>(`/post/progress`, payload);
  return response.data;
};

export const postEdit = async (payload: FormData): Promise<IPostEditResponse> => {
  const id = payload.get('id') as string;
  const response = await apiMultipart.put<IPostEditResponse>(`/post/${id}`, payload);
  return response.data;
};

/**
 * Fetches paginated posts with optional filters
 * Uses POST method as per backend pattern for pagination endpoints
 */
export const getPost = async (query: IPostQuery): Promise<IPostListResponse> => {
  const response = await api.get<IPostListResponse>(`/post/all`, { params: query });
  return response.data;
};

/**
 * Fetches paginated comments for a specific post
 */
export const getCommentsForPost = async (
  postId: string,
  page: number = 1,
  pageSize: number = 10,
): Promise<ICommentsResponse> => {
  const response = await api.get<ICommentsResponse>(
    `/post/comments/${postId}?page=${page}&pageSize=${pageSize}`,
  );
  return response.data;
};
